'use strict';

const {yItemTitleWatcher} = require("../../../watchers/yItemTitleWatcher");
const {yItemStartWatcher} = require("../../../watchers/yItemStartWatcher");
const {getWidgetData} = require("../../../functions/widgetsData");
const {ITEM_STATE_SCHEDULED} = require("../../../vars/itemStatus");

module.exports = [
    function () {
        return {
            templateUrl: '/partial/app.partials.rundown.directives.navigation_item',
            replace: true,
            controller: [
                '$timeout',
                '$element',
                '$scope',
                '$state',
                '$rootScope',
                'widgets',
                'yReader',
                rmRundownNavigationItemCtrl
            ],
            controllerAs: 'ctrl',
            scope: {
                yItem: '=',
                block: '=',
                extraItemData: '=',
                badgeType: '=',
                dragging: '=',
                widgetDragging: '=',

                deleteItemCb: '&',
                createItemAfterCb: '&',

                onDragStartCb: '&',
                onDragEndCb: '&',
                onSelectedCb: '&',

                currentFilters: '=',
                readOnly: '=',
                isCreateItemAllowed: '=',

                itemModelTypes: '=',
            },
            link: function (scope, element, attributes, controllers) {
            },
        };
    }];

class rmRundownNavigationItemCtrl {
    constructor($timeout, $element, $scope, $state, $rootScope, widgets, yReader) {
        this.observeDeep = this.observeDeep.bind(this);
        this.initWidgets = this.initWidgets.bind(this);
        this.destroy = this.destroy.bind(this);

        const {yItem} = $scope;

        this.$timeout = $timeout;
        this.$element = $element;
        this.$state = $state;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.widgets = widgets;
        this.yReader = yReader;
        this.yItem = yItem;
        this.itemId = yItem.get('id');

        $scope.widgetData = null;
        this.badgeTypeWatch = $scope.$watch('badgeType', badgeType => {
            if (!badgeType) {
                $scope.widgetData = null;
                return;
            }
            $scope.widgetData = getWidgetData(yItem, badgeType);
        });

        this.readOnly = $scope.readOnly;
        if (!$rootScope.blockMayAllowTemplate[$scope.block.id]) {
            $rootScope.blockMayAllowTemplate[$scope.block.id] = [];
        }

        this.updateTemplateStatus();
        this.yItem.observeDeep(this.observeDeep);

        this.init();

        $scope.$on('$destroy', this.destroy);

        this.focusListener = (event) => {
            const {focus} = event.detail;
            if ($scope.extraItemData) {
                $scope.extraItemData.selected = focus;
            }
        };

        window.addEventListener(
            `prep-focus-${this.itemId}`,
            this.focusListener,
        );

        this.navigationTitle = yItemTitleWatcher(yItem, title => {
            $scope.$applyAsync(() => {
                this.nav_title = title;
            });
        });

        this.navigationStart = yItemStartWatcher(yItem, start => {
            $scope.$applyAsync(() => {
                this.nav_time = start;
            });
        });

        this.debounceUpdateTemplateStatus = _.debounce(() => {
            this.updateTemplateStatus();
            $scope.$apply();
        }, 25);

    }

    observeDeep(events) {
        for (const event of events) {

            if (event.path[0] === 'widgets_data') {
                const {$scope, yItem} = this;
                if ($scope.badgeType && event.keysChanged.has($scope.badgeType)) {
                    $scope.$applyAsync(() => {
                        $scope.widgetData = getWidgetData(yItem, $scope.badgeType);
                    });
                }
                continue;
            }

            if (event.keysChanged instanceof Set) {
                if (event.keysChanged.has('status')) {
                    this.debounceUpdateTemplateStatus();
                }
            }

        }
    }


    updateTemplateStatus() {
        let blockId = this.$scope.block.id;
        let itemId = this.itemId;
        let index = this.$rootScope.blockMayAllowTemplate[blockId].indexOf(itemId);
        if (this.yItem.get('status') === ITEM_STATE_SCHEDULED) {
            if (index !== -1) this.$rootScope.blockMayAllowTemplate[blockId].splice(index, 1);
        } else if (index === -1) {
            this.$rootScope.blockMayAllowTemplate[blockId].push(itemId);
        }
    }


    getModelType(itemModelTypeId) {
        const itemModelTypes = this.$scope.itemModelTypes
        return itemModelTypes.find(modelType => modelType.id === itemModelTypeId) ||
          itemModelTypes.find(modelType => String(modelType.id) === String(itemModelTypeId))
    }


    initWidgets() {
        const {
            yItem,
            widgets,
            $scope,
        } = this;

        const modelType = this.getModelType(yItem.get('model_type_id'));
        const widgetIds = modelType.widgets.map(widget => widget.id);
        const newWidgetsIds = JSON.stringify(widgetIds);

        $scope.model_type = modelType;

        if (this.oldWidgetIds === newWidgetsIds) {
            return;
        }
        this.oldWidgetIds = newWidgetsIds;

        widgets.getWidgetsByType('rundown_item').then(itemWidgets => {
            itemWidgets = itemWidgets.filter(widget => widgetIds.indexOf(widget.id) !== -1);
            $scope.itemWidgetDataKeys = itemWidgets.map(widget => widget.data_key);
            $scope.itemWidgets = itemWidgets;
        });
    }


    init() {
        this.yReader('static_start', 'y-bool', this.yItem, this.$scope, null, true);
        this.yReader('model_type_id', 'text', this.yItem, this.$scope, this.initWidgets);
        this.yReader('status', 'text', this.yItem, this.$scope);

        this.initWidgets();
    }


    // canDrag() {
    //
    //     if (this.readOnly) {
    //         return false;
    //     }
    //     for (let filter in this.currentFilters) {
    //         if (this.currentFilters.hasOwnProperty(filter)) {
    //             if (!this.currentFilters[filter].enabled) {
    //                 return false;
    //             }
    //         }
    //     }
    //     return true;
    // }

    edit() {
        this.$state.go('.edit', {
            type: 'block',
            itemId: this.itemId,
            blockId: this.$scope.block.id,
        });
    }


    destroy() {
        const {
            $rootScope,
            $scope,
            yItem,
        } = this;

        let index = $rootScope.blockMayAllowTemplate[$scope.block.id].indexOf(yItem.get('id'));
        if (index !== -1) $rootScope.blockMayAllowTemplate[$scope.block.id].splice(index, 1);
        $scope.extraItemData = undefined;

        if (yItem.get('id') === $rootScope.progressItem) {
            $rootScope.progressItem = null;
            $rootScope.progress = 0;
        }


        if (this.focusListener) {
            window.removeEventListener(
                `prep-focus-${this.itemId}`,
                this.focusListener,
            );
        }

        this.navigationTitle();
        this.navigationStart();

        this.badgeTypeWatch();
        yItem.unobserveDeep(this.observeDeep);
    }


    onWidgetDrop(event, widgetData) {
        const {
            widgets,
            yItem,
            $scope: {
                itemWidgetDataKeys,
                widgetDragging,
            },
        } = this;

        if (itemWidgetDataKeys.indexOf(widgetDragging.dataKey) === -1) {
            return;
        }

        if (typeof widgetData === 'object' && widgetData.id) {
            console.log(event, widgetData);

            widgets.sendMessage(widgetData.id, 'droppedOnItem', {
                itemId: yItem.get('id'),
                customData: widgetData.customData
            })
        } else {
            console.error('data that was dropped was not an valid widget object!');
        }

        return true;
    }
}
